import { createContext } from "react";
import { ITenant, NoTenant } from "interfaces/tenant";

const TenantContext = createContext({
  tenant: NoTenant,
  setTenant: (tenant: ITenant) => {}
});

export default TenantContext;